export const ROOT = "/";
export const OVERVIEW = "/overview";
export const ANONYMOUS_OVERVIEW = "/overview/:responseId";
export const BREAKDOWN = "/breakdown";
export const ANONYMOUS_BREAKDOWN = "/breakdown/:responseId";
export const LOGIN = "/login";
